import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Card, CardBody, CardTitle, Collapse, Button } from 'reactstrap';
import styled from "styled-components";
const StyledCardTitle = styled(CardTitle)`
  cursor: pointer;
`;
/**
 * Portlet
 */

class ExpandableCard extends Component {
  constructor(props) {
    super(props);
    this.toggleContent = this.toggleContent.bind(this);
    this.state = {
      collapse: true
    };
  }
  /**
   * Toggle the body
   */

  /*:: toggleContent: () => void */


  toggleContent() {
    this.setState(state => ({
      collapse: !state.collapse
    }));
  }

  render() {
    const children = this.props.children || null;
    return !this.state.hidden ? /*#__PURE__*/React.createElement(Card, {
      className: classNames(this.props.className)
    }, /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement("div", {
      className: "card-widgets"
    }, /*#__PURE__*/React.createElement(Button, {
      color: "link",
      className: "card-action",
      onClick: this.toggleContent
    }, /*#__PURE__*/React.createElement("i", {
      className: classNames('mdi', {
        'mdi-minus': this.state.collapse,
        'mdi-plus': !this.state.collapse
      })
    }))), /*#__PURE__*/React.createElement(StyledCardTitle, {
      tag: "h5",
      className: "mb-0",
      onClick: this.toggleContent
    }, this.props.title), /*#__PURE__*/React.createElement(Collapse, {
      isOpen: this.state.collapse,
      className: "pt-3"
    }, children))) : null;
  }

}

export default ExpandableCard;